<script>
	import { onMount } from 'svelte';
	import { getText, jumpByAnchor } from '../../../../../share/utils';

	let div_team;

	onMount(() => {
		jumpByAnchor(div_team);
	});
</script>

<div bind:this={div_team} id="team" class="page-agency--team marginbox">
	<div class="flex structure">

		<div class="flex col structure-4">
			<div class="flex structure-4-1">
				<div class="flex element">
					<img loading="lazy" alt="Agentur - Winners" src="/img/02.Agentur/07.Jobs/05.details/dogs.webp">
				</div>
			</div>

			<div class="flex col structure-4-2">
				<div class="flex element">
					<img loading="lazy" alt="Agentur - Table" src="/img/02.Agentur/07.Jobs/05.details/table.webp">
				</div>

				<div class="flex element">
					<div class="card text card_w51">
						<h2 class="balance">{getText("02.04.03_quote")}</h2>
						<h2 class="imageoverlay balance">{getText("02.04.03_quote")}</h2>
					</div>
				</div>
			</div>
		</div>

	</div>
</div>

<style lang="scss">
	@import "../../../../../style/mixins";
	@import "../../../../../style/variables";

	img {
		width: 100%;
		margin: 0;
		padding: 0;
	}

	.img-single {
		margin: $spacing-mobile $spacing-mobile $media-gap $spacing-mobile;
	}

	.right {
		text-align: right;

		@include for-tablet-portrait-up {
			justify-content: end;
		}
	}

	.page-agency--team {
		h2 {
			margin-bottom: $media-gap;

			&.imageoverlay {
				position: absolute;
			}
		}

		.flex {
			display: flex;
			box-sizing: border-box;
		}

		.row {
			flex-flow: row wrap;
		}

		.col {
			flex-flow: column;
		}

		.element {
			min-width: 100px;
			/*align-self: center;*/
		}

		.commercial {
			position: relative;
			width: 100%;
			height: 100%;
		}

		.content {
			flex: 1 100%;
		}

		.structure {
			flex-flow: row wrap;
			justify-content: space-between;
		}

		.structure-1 {
			width: 100%;
			margin-top: $spacing-mobile;
			margin-bottom: $media-gap;

			@include for-tablet-portrait-up {
				margin-bottom: 0;
				flex-flow: row nowrap;
			}

			.element {
				@include for-tablet-portrait-up {
					width: 50%;
				}
			}

			.element:first-of-type {
				@include for-tablet-portrait-up {
					padding-right: $media-gap;
				}
			}

			img {
				margin-bottom: $media-gap;
			}
		}

		.structure-2 {
			flex-shrink: 0;
			width: 100%;
			justify-content: start;

			@include for-tablet-portrait-up {
				.element:first-of-type {
					width: 25%;
					padding-right: $media-gap;
				}

				.element:nth-of-type(2) {
					width: 75%;
				}
			}

			img {
				margin-bottom: $media-gap;
			}
		}

		.structure-3 {
			width: 100%;
			margin-bottom: $media-gap;

			.card {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.card_w49 {
				width: 49%;
			}
		}

		.structure-4 {
			img {
				margin-bottom: $media-gap;
			}

			@include for-tablet-portrait-up {
				flex-flow: row nowrap;
			}

			.structure-4-1 {
				img {
					height: fit-content;
				}

				@include for-tablet-portrait-up {
					padding-right: $media-gap;
				}
			}

			.structure-4-2 {
				position: relative;
				@include for-tablet-portrait-up {
					width: 50%;
				}

				img {
					height: auto;

					@include for-tablet-portrait-up {
						width: 100%;
					}
				}

				.element {
					width: 100%;
					height: 100%;
				}

				.card_w51 {
					width: 100%;
					position: relative;

					@include for-phone-only {
						width: 60%;
						margin-right: 40%;
					}
					@include for-tablet-portrait-up {
						text-align: right;
						margin-left: -100px;
						width: calc(100% + 100px);
						max-width: calc(100% + 100px);
					}
					@include for-tablet-landscape-up {
						margin-left: -5vw;
						width: calc(100% + 5vw);
						max-width: calc(100% + 5vw);
					}
				}

				h2 {
					margin-bottom: 0;
					z-index: -1;
					color: #0c0c0c;
					position: absolute;
					left: 0;
					top: 0;
					width: 100%;
					min-width: 50%;

					&.imageoverlay {
						z-index: 10 !important;
						color: #EEE !important;
						mix-blend-mode: color-dodge;
					}
				}
			}
		}

		.text {
			margin-bottom: $media-gap;

			@include for-tablet-portrait-up {
				max-width: 70%;
			}
		}
	}
</style>
